import HeroDesktop from "./hero-desktop/";
import HeroMobile from "./hero-mobile/";

const modul = angular
    .module("heroComponents", [])

    .directive("heroDesktop", HeroDesktop)
    .directive("heroMobile", HeroMobile);

export default modul.name;
